module.exports = __webpack_public_path__ + "img/프리스트.44ed4d7e.png";